export enum Site {
  CALCULEO = 'calculeo',
  EFFY = 'effy',
  LPE = 'lpe',
  QE = 'qe',
}

export type AllSites = Site;
